import { installTwicpics } from '@twicpics/components/react'

const TWICPICS_DOMAIN = process.env.TWICPICS_DOMAIN ?? ''

const TwicpicsImagesProvider = (): JSX.Element => {
  installTwicpics({
    domain: TWICPICS_DOMAIN,
  })

  return <></>
}

export default TwicpicsImagesProvider
